var _a;
import { createActions, createAction } from 'redux-actions';
export var getFilterComplete = (_a = createActions('GET_FILTER_COMPLETE', 'GET_FILTERS', 'GET_FILTERS_COMPLETE'), _a.getFilterComplete), getFilters = _a.getFilters, getFiltersComplete = _a.getFiltersComplete;
export var getFilter = createAction('GET_FILTER', function (payload) { return payload; }, function (payload, params) { return ({ params: params }); });
